export default function isChromium() {
  return 'chrome' in window;
}
